module.exports = __webpack_public_path__ + "img/logo.9c212d40.png";